import {
    Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle,
    Divider, Grid, IconButton, MenuItem, TextField, Chip,
    Backdrop,
    CircularProgress
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { useState } from "react";
import { LinkAssetConfirmDialog } from "./LinkAssetConfirmDialog";
import { useAvailableMainAssets } from "../stressEntry/stressEntryQueries";
import { Error } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";

export const LinkNewAssetDialog = ({ open, onClose }: any) => {
    const [selectedPrimaryAsset, setSelectedPrimaryAsset] = useState('');
    const [selectedSubAsset, setSelectedSubAsset] = useState<string[]>([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [errors, setErrors] = useState<{ primary?: string; sub?: string }>({});


    const {
        error: errorMainAsset,
        data: primaryAssets,
        isLoading: isLoadingMainAsset,
        isError: isErrorMainAsset,
    } = useAvailableMainAssets(true);

    const {
        error: errorAsset,
        data: subAssets,
        isLoading: isLoadingAsset,
        isError: isErrorAsset,
    } = useAvailableMainAssets(false);


    if (isLoadingAsset || isLoadingMainAsset) {
        return (
            <CircularProgress></CircularProgress>
        )
    }

    if (isErrorAsset || isErrorMainAsset) {
        return (
            <Error></Error>
        )
    }

    const payload = {
        sub_asset_ids: selectedSubAsset,
        asset_calibration_id: Number(selectedPrimaryAsset),
    };

    const namePayload = {
        sub_asset_names: selectedSubAsset.map((id) => {
            const asset = subAssets.find((a: any) => a.id === id);
            return asset ? asset.asset_name : id;
        }),
        asset_calibration_name: (() => {
            const asset = primaryAssets.find((a: any) => a.id === selectedPrimaryAsset);
            return asset ? asset.asset_name : "";
        })(),
    };


    const handlePrimaryAssetChange = (value: any) => {
        setSelectedPrimaryAsset(value);
    };

    const handleSubAssetChange = (e: any) => {
        setSelectedSubAsset(e.target.value as string[]);
    };

    const handleDialogOpen = () => {

        if (validate()) {
            setOpenDialog(true);
        }
        console.log("Payload", payload)
    };

    const handleCloseDialog = () => {
        setSelectedSubAsset([]);
        setSelectedPrimaryAsset('');
        setOpenDialog(false);
        onClose();
    };

    const validate = () => {
        const newErrors: { primary?: string; sub?: string } = {};
        if (!selectedPrimaryAsset) newErrors.primary = "Please select a primary asset.";
        if (!selectedSubAsset.length) newErrors.sub = "Please select at least one sub-asset.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const menuProps = {
        PaperProps: { style: { maxHeight: 350, width: 300 } },
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
        getContentAnchorEl: null,
    };

    return (

        <>
            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
                <DialogTitle>
                    <Grid container alignItems="center">
                        <Grid item xs>Link New Asset</Grid>
                        <Grid item>
                            <IconButton onClick={onClose}><CloseIcon /></IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>

                <Divider />

                <DialogContent dividers>
                    <Grid container spacing={4}>
                        <Grid item xs={6} style={{ marginTop: 20 }}>
                            {/* <TextField
                                id="primary_asset"
                                label="Select primary asset"
                                select
                                variant="filled"
                                value={selectedPrimaryAsset}
                                onChange={handlePrimaryAssetChange}
                                fullWidth
                                error={!!errors.primary}
                                helperText={errors.primary}
                                SelectProps={{
                                    MenuProps: menuProps as any,
                                    renderValue: (selected: unknown) => {
                                        const asset = primaryAssets.find((a: any) => a.id === selected);
                                        return asset ? asset.asset_name : "None";
                                    },
                                }}
                            >
                                {primaryAssets.map((item: any) => (
                                    <MenuItem key={item.id} value={item.id} disabled={item.in_use && !item.is_calibration}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item>
                                                {item.asset_name}
                                            </Grid>

                                            <Grid item>
                                                {item.is_calibration_date && (
                                                    <Grid item>
                                                        <Chip
                                                            label={`● Calibration due in ${item.asset_next_calibration} days`}
                                                            size="small"
                                                            style={{ color: "red", borderColor: "red" }}
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </MenuItem>
                                ))}
                            </TextField> */}
                            <Autocomplete
                                options={primaryAssets}
                                getOptionLabel={(option: any) => option.asset_name || ""}
                                value={
                                    primaryAssets.find((a: any) => a.id === selectedPrimaryAsset) || null
                                }
                                onChange={(event, newValue) => {
                                    handlePrimaryAssetChange(newValue ? newValue.id : '');
                                }}
                                getOptionDisabled={(option: any) => option.in_use && !option.is_calibration}
                                renderOption={(option: any) => (
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item>{option.asset_name}</Grid>

                                        {option.is_calibration_date && (
                                            <Grid item>
                                                <Chip
                                                    label={`● Calibration due in ${option.asset_next_calibration} days`}
                                                    size="small"
                                                    style={{ color: "red", borderColor: "red" }}
                                                    variant="outlined"
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select primary asset"
                                        variant="filled"
                                        error={!!errors.primary}
                                        helperText={errors.primary}
                                    />
                                )}
                            />

                        </Grid>


                        <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                            {/* <TextField
                                id="sub_asset"
                                label="Select sub-assets"
                                select
                                variant="filled"
                                value={selectedSubAsset} // ✅ holds array of IDs now
                                onChange={handleSubAssetChange}
                                fullWidth
                                error={!!errors.sub}
                                helperText={errors.sub}
                                SelectProps={{
                                    multiple: true,
                                    MenuProps: menuProps as any,
                                    renderValue: (selected: any) => {
                                        if (!selected.length) return "None";
                                        return selected
                                            .map((id: number) => {
                                                const a = subAssets.find((s: any) => s.id === id);
                                                return a ? a.asset_name : id;
                                            })
                                            .join(", ");
                                    },
                                }}
                            >
                                {subAssets.map((item: any) => (
                                    <MenuItem
                                        key={item.id}
                                        value={item.id}  // ✅ use id, not name
                                        disabled={item.in_use && !item.is_calibration}
                                    >
                                        <Grid container alignItems="center" spacing={1}>
                                            
                                            <Grid item>
                                                <Checkbox checked={selectedSubAsset.includes(item.id)} /> 
                                            </Grid>

                                            
                                            <Grid item>
                                                {item.asset_name}
                                            </Grid>

                                            
                                            {item.is_calibration_date && (
                                                <Grid item>
                                                    <Chip
                                                        label={`● Calibration due in ${item.asset_next_calibration} days`}
                                                        size="small"
                                                        style={{ color: "red", borderColor: "red" }}
                                                        variant="outlined"
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </MenuItem>
                                ))}
                            </TextField> */}

                            <Autocomplete
                                multiple
                                options={subAssets}
                                disableCloseOnSelect
                                getOptionLabel={(option: any) => option.asset_name || ""}
                                value={subAssets.filter((a: any) => selectedSubAsset.includes(a.id))}
                                onChange={(event, newValue) => {
                                    setSelectedSubAsset(newValue.map((item: any) => item.id));
                                }}
                                getOptionSelected={(option, value) => option.id === value.id}
                                getOptionDisabled={(option: any) => option.in_use && !option.is_calibration}
                                fullWidth
                                renderOption={(option: any, { selected }) => (
                                    <Grid container alignItems="center" spacing={1}>
                                        {/* Checkbox */}
                                        <Grid item>
                                            <Checkbox checked={selected} />
                                        </Grid>

                                        {/* Name */}
                                        <Grid item>
                                            {option.asset_name}
                                        </Grid>

                                        {/* Calibration Chip */}
                                        {option.is_calibration_date && (
                                            <Grid item>
                                                <Chip
                                                    label={`● Calibration due in ${option.asset_next_calibration} days`}
                                                    size="small"
                                                    style={{ color: "red", borderColor: "red" }}
                                                    variant="outlined"
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select sub-assets"
                                        variant="filled"
                                        error={!!errors.sub}
                                        helperText={errors.sub}
                                    />
                                )}
                            />

                        </Grid>

                        <Grid item xs={12}>
                            <Grid container justifyContent="center" spacing={2} style={{ marginTop: 24, marginBottom: 10 }}>
                                <Grid item>
                                    <Button onClick={onClose} variant="contained" color="secondary">CANCEL</Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="primary" onClick={handleDialogOpen}>LINK NEW ASSET</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>


            <LinkAssetConfirmDialog
                open={openDialog}
                onClose={handleCloseDialog}
                payload={payload}
                namepayload={namePayload}
                mode="add"
            />

        </>
    );
};
